import TrustpilotRecoverInvitationService from '../module/ecocode-trustpilot/service/trustpilot-recover-invitation.service';

Shopware.Application.addServiceProvider('ecocodeTrustpilotRecoverInvitationService', container => {
    const initContainer = Shopware.Application.getContainer('init');
    return new TrustpilotRecoverInvitationService(initContainer.httpClient, container.loginService, Shopware.Context.api);
});
